export const START_CALL = "START_CALL_REVIEW";
export const CALL_COMPLETED = "CALL_COMPLETED_REVIEW";
export const CATCH_ERROR = "CATCH_ERROR_REVIEW";

// commands
export const RATE_APP = "RATE_APP";
export const LIKE_APP = "LIKE_APP";
